import { styled } from '@linaria/react';

export const ProfileCardHeaderAvatar = styled.div`
	display: flex;
	overflow: hidden;
	width: 7.2rem;
	height: 7.2rem;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	margin-bottom: 0.8rem;
	font-size: var(--font-size-4xl);
	line-height: 100%;
`;
